import React from 'react';
import useStyles from './styles';
import { Typography } from '@material-ui/core';
import JetButton from '@src/shared/components/JetButton';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import InitialAnimatedBackground from '../InitialAnimatedBackground';
import NonAnimatedDashBoardImage from '@assets/non-animated-tablet.png'
import { useTranslation } from 'react-i18next';
const ManagerInitialContent = (props : any) => {
  const {isResolutionMobile} = useDeviceDetect()
  const classes = useStyles();
  const { t } = useTranslation()
  return (
    <div className={classes.managerInitialContentContainer} id='main-initial-content-container'>
     {!isResolutionMobile && <InitialAnimatedBackground />}
      <div className={classes.managerInitialContent}>
        <Typography variant={isResolutionMobile ? `h3` : `h1`} className={`manager-initial-content-title ${isResolutionMobile ? `heading_l` : `heading_xxl`} `} align={isResolutionMobile ? 'left' : 'center'}>
          {t(`new_productoverview_manager.section1_title`)}
        </Typography>
        <Typography variant="body1" className={isResolutionMobile ? `body_regular` : `subheading_s`} align={isResolutionMobile ? 'left' : 'center'}>
        {t(`new_productoverview_manager.section1_description`)}
        </Typography>
        <JetButton onClick={props.onAction} size={isResolutionMobile ? 'medium' : 'large'} variation="primary">
          {t('new_productoverview_manager.section1_get_started')}
        </JetButton>
        <div className='content-image'>
          <img src={NonAnimatedDashBoardImage} />
        </div>
      </div>
    </div>
  );
};

export default ManagerInitialContent;
